import { defineComponent as _defineComponent } from 'vue'
import BCXFormValues from '@/components/molecules/forms/BCXFormValues.vue';
import { computed, PropType } from 'vue';
import { BcxFormValueField } from '@/models/BcxForm';
import useCurrency from '@/mixins/useCurrency';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositionsSum',
  props: {
  sum: {
    type: Object as PropType<any>,
    required: true
  }
},
  setup(__props) {

const { tUserFallback: t } = useUser('self');



const { format: currencyFormat } = useCurrency();

const { isMobileWidth } = useResponsiveness();

const verticalGap = isMobileWidth.value ? '32px' : '24px';

const sumFields = computed(() => {
  const isMobile = isMobileWidth.value;
  const fields:BcxFormValueField[] = [
    {
      name: 'totalNet',
      width: isMobile ? '50%' : '33%',
      label: `${t('invoice.positions.form.totalNet_USERTYPE')}`
    },
    {
      name: 'addedVAT',
      width: isMobile ? '50%' : '33%',
      label: `${t('invoice.positions.form.addedVAT_USERTYPE')}`
    },
    {
      name: 'totalAmount',
      width: isMobile ? '50%' : '33%',
      label: `${t('invoice.positions.form.totalAmount_USERTYPE')}`,
      justify: isMobile ? 'end' : 'start'
    }
  ];
  return fields;
});

return { __sfc: true,t, currencyFormat, isMobileWidth, verticalGap, sumFields, BCXFormValues }
}

})